<div *ngIf="displayMode=='Tbl'" class="success_page_tbl">
    <div style="text-align: end;">
        <button class="button darkblue" (click)="newPage()">
            <i class="pi pi-plus"></i>
            <span i18n="@@New">New</span>
        </button>
    </div>
    <div class="card">
        <p-table #dt
                [value]="listPages"
                [paginator]="true"
                [rows]="10"
                 [totalRecords]="totalPage"
                 [lazy]="true"
                 (onLazyLoad)="loadListPages(dt)"
                [showCurrentPageReport]="true"
                [tableStyle]="{ 'min-width': '50rem' }"
                [currentPageReportTemplate]="farsitableTemplate(dt.first,totalPage)"

                [paginatorLocale]="locale=='fa'?'fa-IR':''"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:25%" i18n="@@name">name</th>
                    <th style="width:25%" i18n="@@Address">Address</th>
                    <th style="width:25%" i18n="@@Title">Title</th>
                    <th  i18n="@@Create Date">Create Date</th>
                    <th  i18n="@@priority">priority</th>
                    <th  i18n="@@Publish">Publish</th>
                    <th style="width:25%"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-page>
                <tr>
                    <td>{{ page.name }}</td>
                    <td style="direction: ltr;" >
                        <div style="cursor: pointer;" (click)="window.open('/success_story/'+page.uid,'_blank') ">{{'/success_story/'+page.uid }}</div>
                        <div style="cursor: pointer;" (click)="window.open('/success_story/'+page.name,'_blank') ">{{'/success_story/'+page.name }}</div>
                    </td>
                    <td>{{ page.title }}</td>
                    <td>{{ page.createDate | dateText:'yyyy/mm/dd' |numberText}}</td>
                    <td>{{ page.priority |numberText}}</td>
                    <td><p-checkbox  [binary]="true"  [disabled]="true" [(ngModel)]="page.active"></p-checkbox></td>
                    <td>
                        <div class="operation-icons">
                            <i class="pi pi-pencil" (click)="editPage(page)"></i>
                            <i class="pi pi-trash" (click)="deletePage(page,dt)"></i>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft">
            </ng-template>
            <ng-template pTemplate="paginatorright">
            </ng-template>
        </p-table>
    </div>
</div>
<div *ngIf="displayMode=='Edit'" class="success_page_edit">
    <app-admin-edit-page [page]="page" [otherFieldsTitle]="otherFieldsTitle" (cancelSaveEvent)="cancelSaveEvent()" (savePageEvent)="savePageEvent()"></app-admin-edit-page>
</div>




